import { render, staticRenderFns } from "./ComparatorVue.vue?vue&type=template&id=dd42d432"
import script from "./ComparatorVue.vue?vue&type=script&lang=js"
export * from "./ComparatorVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports